import { Area } from 'react-easy-crop';

export const getCroppedImage = (
    imageSrc: string,
    pixelCrop: Area,
): Promise<{ blob: Blob; preview: string }> => {
    return new Promise(async (resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.src = imageSrc;

        img.onload = () => {
            const size = Math.max(pixelCrop.width, pixelCrop.height);
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            if (!ctx) return reject(new Error('No canvas context'));

            canvas.width = size;
            canvas.height = size;

            ctx.drawImage(
                img,
                pixelCrop.x,
                pixelCrop.y,
                pixelCrop.width,
                pixelCrop.height,
                0,
                0,
                size,
                size,
            );

            const previewCanvas = document.createElement('canvas');
            const pctx = previewCanvas.getContext('2d')!;
            previewCanvas.width = size;
            previewCanvas.height = size;

            pctx.save();
            pctx.beginPath();
            pctx.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2);
            pctx.closePath();
            pctx.clip();
            pctx.drawImage(canvas, 0, 0);
            pctx.restore();

            previewCanvas.toBlob((previewBlob) => {
                if (!previewBlob) return reject(new Error('Preview failed'));
                const reader = new FileReader();
                reader.onloadend = () => {
                    const dataUrl = String(reader.result);
                    canvas.toBlob(
                        (blob) => {
                            if (!blob) return reject(new Error('Cropping failed'));
                            resolve({ blob, preview: dataUrl });
                        },
                        'image/jpeg',
                        0.92,
                    );
                };
                reader.readAsDataURL(previewBlob);
            }, 'image/png');
        };

        img.onerror = reject;
    });
};
